
const saveTemplateDetailsUsedForAddEvent = (template)  => {
   return {
      type: 'SAVE_TEMPLATE_DETAILS_USED_FOR_ADD_EVENT',
      payload: template,
   }
}

export default saveTemplateDetailsUsedForAddEvent;



// WEBPACK FOOTER //
// ./src/actions/events/saveTemplateDetailsUsedForAddEventAction.js